import styled from 'styled-components';
import { Row } from 'components/shared/Layout';
import AlertBox from 'components/ui/AlertBox';
import { BREAKPOINTS } from 'constants/breakpoints';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const StyledRow = styled(Row)`
  position: sticky;
  top: 250px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    top: 16px;
  }
`;

export const StyledAlertBox = styled(AlertBox)`
  margin: 0 0 8px;
`;
